
import MirroringScreen from "../../../assets/duotone/MirroringScreen.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MirroringScreenIcon({ className, dataTestid = "MirroringScreenIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MirroringScreen data-testid={dataTestid} className={classes} {...rest} />
  );
}
